<template>
  <div v-if="visible" class="upload-box">
    <div v-show="!isLoading" :class="['upload-content', isAiDrop ? 'upload-content-ai' : '']">
      <div class="upload-content-title">
        {{ isAiDrop ? 'ai分析导入' : '文件上传'}}
      </div>
      <div class="upload-content-main">
        <template v-if="isAiDrop">
          <div class="ai-answers">
            <div class="tips">我是AI分析导入助手，需要什么帮助？</div>
            <div class="tips" style="font-size: 14px;">您可以将格式为word,excel,pdf格式文件拖入,并说出你的需求,我会帮您进行分析！</div>
            <!-- 输入框区域 -->
            <div class="file-name">{{ uplaodTemplate }}</div>
            <div class="input-area-wrap" :class="{ 'active': isDragover }" @dragover.prevent="handleDragover" @dragleave.prevent="handleDragleave" @drop.prevent="handleDrop">
              <div class="input-area" :class="{ 'input-border': queryMessage }">
                <textarea v-model="queryMessage" ref="editor" :placeholder="isAiDrop ? '文件拖动到此处即可上传' : '可以问我任何问题哦~'" @keydown.enter.prevent="communicate"></textarea>
                <div class="input-tools">
                  <!-- <div class="fr">
                    <template v-if="!queryMessage">
                      <el-tooltip content="请输入你的问题" placement="top" effect="dark">
                        <span class="btn-submit">
                          <i class="el-icon-top"></i>
                        </span>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <span class="btn-submit btn-submit-high" @click="communicate">
                        <i class="el-icon-top"></i>
                      </span>
                    </template>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="download-btn-title">支持上传文件类型为：xlsx,xls,csv</div>
          <el-upload
            :action="apiurl + '/userfile/upload?accesstoken=' + token"
            :multiple="false"
            drag
            accept=".xlsx, .xls, .csv"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <div class="download-btn">
              <template v-if="uplaodTemplate">
                <div class="top">
                  <i class="iconfont icon-xuanzhong"></i>
                </div>
                <div class="bottom">
                  <span>
                    <i class="iconfont icon-EXCEL"></i>
                    <span>{{ getFileName(uplaodTemplate) }}</span>
                  </span>
                  <span>上传完成</span>
                </div>
              </template>
              <template v-else>
                <i class="iconfont icon-EXCEL"></i>
                <span>上传文件</span>
              </template>
            </div>
          </el-upload>
        </template>
      </div>
      <div class="upload-content-bottom">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" @click="submit">确定</el-button>
      </div>
    </div>
    <aiParseLoad v-if="isLoading" ref="parseLoading" @close="isLoading = false" />
  </div>
</template>
<script>
import util from '@/api/util'
import { ElMessage, ElUpload, ElButton } from 'element-plus'
import axios from 'axios'
import { axiosBase } from '@/api/api'
import { defineAsyncComponent } from 'vue'
export default {
  name: 'importExcelDialog',
  props: {
    visible: Boolean,
    isAiDrop: Boolean,
    aiTips: String,
    approvalId: [String, Number],
    onConfirm: Function,
    onCancel: Function,
    aiDropFile: String
  },
  data () {
    return {
      uplaodTemplate: '',
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      apiurl: util.apiUrl(),
      queryMessage: '',
      isDragover: false,
      isLoading: false
    }
  },
  watch: {
    aiDropFile: {
      handler (val) {
        if (val) {
          this.uplaodTemplate = 'userfiles/' + val
        }
      },
      immediate: true
    }
  },
  components: {
    ElUpload,
    ElButton,
    aiParseLoad: defineAsyncComponent(() => import('./aiParseLoad'))
  },
  methods: {
    communicate() {},
     // 文件上传成功
    handleSuccess (res) {
      this.uplaodTemplate = 'userfiles/' + res
    },
    getFileName (name) {
      if (name) {
        const mps = name.split('/')
        const mp = mps[mps.length - 1]
        const strArr = mp.split('-')
        if (strArr.length > 1) {
          strArr.shift()
        }
        name = strArr.join('-')
      }
      return name
    },
    // 取消
    cancel () {
      this.uplaodTemplate = ''
      this.onCancel()
    },
    submit () {
      if (this.uplaodTemplate) {
        if (this.isAiDrop) {
          this.isLoading = true
          this.getAiFormData(this.uplaodTemplate)
        } else {
          this.onConfirm(this.uplaodTemplate)
        }
      } else {
        ElMessage.warning('请上传文件')
      }
    },
    async getAiFormData(fileUrl) {
      if (fileUrl) {
        const params = {
          approvalId: this.approvalId,
          question: this.aiTips.replace(/<[^>]+>/g, '') + '。' + this.queryMessage,
          file: fileUrl.search('userfiles') === -1 ? ('userfiles/' + fileUrl) : fileUrl
        }
        const { code, data } = await axiosBase(params, '/api/getautoimportapprovaldata')
        this.$refs.parseLoading.parseCompleted()
        if (code === 0 && Array.isArray(data)) {
          this.onConfirm(data, true)
        } else {
          this.$message.warning('解析文件失败，请检查上传文件是否正确！')
        }
      }
    },
    handleDragover () {
      this.isDragover = true
    },
    handleDragleave () {
      this.isDragover = false
    },
    handleDrop(event) {
      this.isDragover = false
      const droppedFiles = event.dataTransfer.files
      if (this.isAiDrop && droppedFiles.length > 0) {
        this.uploadFile(droppedFiles[0])
      }
    },
    // 单个文件上传
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await axios.post(`/userfile/upload?accesstoken=${this.token}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        this.uplaodTemplate = response.data
      } catch (error) {
        console.error('文件上传失败:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .upload-box {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
    z-index: 999;
  }
  .upload-content {
    width: 500px;
    margin: 0 auto;
    margin-top: 10%;
    padding: 14px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background: #FFF;
    border-radius: 5px;
    &-title {
      font-size: 16px;
      margin-bottom: 10px;
    }
    &-main {
      padding: 10px 0;
      color: #6D7D8F;
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px solid #E4ECEC;
      border-radius: 4px;
      background-color: #F8F9FD;
      :deep(.el-upload .el-upload-dragger) {
        width: 360px;
        height: 180px;
        padding: 0;
        border: none;
      }
      .download-btn, .download-btn-title {
        width: calc(100% - 40px);
        margin-bottom: 8px;
      }
      .download-btn {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        background-color: #FFF;
        border: 1px dashed #4E86FF;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span {
          margin-top: 10px;
        }
        .top {
          flex: 1;
          display: flex;
          align-items: center;
          i {
            font-size: 28px;
          }
        }
        .bottom {
          width: 100%;
          height: 50px;
          border-top: 1px solid #E9E9E9;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &>span {
            margin: 0 20px;
          }
        }
      }
    }
    &-bottom {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
  }
  .upload-content-ai {
    width: 600px;
    .upload-content-main {
      height: 300px;
      .ai-answers {
        display: flex;
        flex-direction: column;
        align-items: center;
        .tips {
          color: #000000;
          font-weight: 400;
          font-size: 24px;
          margin-bottom: 26px;
        }
        .file-name {
          color: #999;
          font-size: 12px;
          width: 100%;
          margin: 0 0 8px 45px;
        }
        .input-area-wrap {
          width: 90%;
          border-radius: 24px;
          border: 1px solid #E5E8EE;
          margin-bottom: 26px;
          transition: all 0.3s ease;
          .input-area {
            margin: -1px;
            border-radius: 24px;
            background-color: #F3F4F6;
            border: 1px solid #E7EAF0;
            padding: 12px;
            box-sizing: border-box;
            transition: all 0.3s;

            &.input-border {
              border-color: #4475EB;
              background-color: #fff;
            }

            textarea {
              width: 100%;
              height: 96px;
              overflow: auto;
              outline: none;
              font-size: 14px;
              color: #000;
              background: transparent;
              border: none;

              &:empty:before {
                content: attr(data-placeholder);
                color: #999;
              }

              &:focus {
                outline: none;
              }
            }
            .upload-tips {
              width: 100%;
              height: 96px;
              text-align: center;
              line-height: 96px;
              border: 2px #666 dotted;
            }
            .input-tools {
              margin-top: 10px;
              display: flex;
              gap: 15px;
              color: #666;
              font-size: 14px;
              justify-content: flex-end;
              align-items: center;

              .fr {
                  display: flex;
                  align-items: center;
                  flex-shrink: 0;

                  .btn-submit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    margin-left: 5px;
                    border-radius: 50%;
                    flex-shrink: 0;

                    i {
                      font-size: 26px;
                    }
                  }

                  .btn-submit {
                    background-color: #D6DEE8;
                    cursor: not-allowed;

                    i {
                      color: #fff;
                    }

                    &.btn-submit-high {
                      background-color: #4E86FF;
                      cursor: pointer;

                      &:hover {
                        background-color: #66b1ff;
                      }
                    }
                  }
                }
            }
          }
        }
        .active {
          border-color: #6ee7ff;
          box-shadow: 0 0 30px rgba(110, 231, 255, 0.2);
          transform: translateY(-5px);
        }
      }
    }
  }
</style>
